const LinkIcon = () => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.97408 11.6204L11.5414 11.5414M11.5414 11.5414L11.6205 1.97406M11.5414 11.5414L0.82319 0.823173"
        stroke="#BEC4D5"
        strokeWidth="2"
      />
    </svg>
  )
}

export default LinkIcon
